import React from 'react';

import { forwardRef, Heading as ChakraHeading } from '@chakra-ui/react';

import { defaultSpacing22 } from '../../default-spacing';
import { HeadingSize22, HeadingV22Props } from '../../types';
import { getSpacingProps } from '../../utils';

const DEFAULT_SIZE: HeadingSize22 = 'title-600';

/**
 * DLS 2.2 Heading — the numeric `title-*` scale.
 *
 * Same shape as 2.1 on purpose: `as` stays the semantic level and `size` the visual step, so
 * `<Heading as="h1" size="title-300">` is normal. The metrics come from the `title-*` text
 * styles (see `component-styles/heading/2.2.ts`); only the step names and the default change.
 *
 * `title-*` is a heading's scale and nothing else's — copy is `Text`'s `body-*`, and display
 * type is `Display`'s `display-*`. An odd non-heading element that genuinely needs a title step
 * can still reach the shared token as `textStyle="title-300"`.
 */
export const HeadingV22 = forwardRef<HeadingV22Props, 'h2'>((props, ref) => {
  const { noDefaultSpacing = false, size = DEFAULT_SIZE, ...rest } = props;

  const spacingProps = noDefaultSpacing
    ? {}
    : getSpacingProps(size, defaultSpacing22);

  return <ChakraHeading ref={ref} size={size} {...spacingProps} {...rest} />;
});

HeadingV22.displayName = 'Heading';
